import type { FaireProductEntity } from "../../entity_types/product";

export const p_4svsnautvx: FaireProductEntity = {
  token: "p_4svsnautvx",
  type: "product",
  name: "Smartest Person In The Room Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/8cb3a53d0053e6cfb6c05182f1bcb241a5b11971deabb5db8f41cf2e7d371726.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96e697d54d548dda8c9b4ba5a51cf216bfd0eebc9445bda6a06c2b3345e1d7d8.jpeg",
    "https://cdn.faire.com/fastly/3aad993490fa91e850fe811a2477a839bf6663aa677048c13fa2e3c566e4845c.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/b0b0d301593f8750b69e1cdc766604eccda9f0d8e1f163722edf1c6678b01a1c.jpeg",
    "https://cdn.faire.com/fastly/d7aaba95dfa0b50325b5b129fcf06b4561a9a0377553140697e4fc8590ecea83.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are perfect for correcting people in your head (and sometimes out loud) in style. 🤓\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:23.114Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
